export function getCorrectIdFromModel(controlId) {
  if (controlId.indexOf('.') !== -1) {
    controlId = controlId.replace('.', 'point')
  }
  return 'item' + controlId
}

export function getIdFromItem(item) {
  if (item.id) {
    return item.id
  }
  let id
  if (item.controlId.indexOf('.') !== -1) {
    id = item.controlId.replace('.', 'point')
  }
  return 'item' + id
}

export function getControlIdFromItem(item) {
  if (item.controlId) {
    return item.controlId
  }
  let controlId
  if (item.id.indexOf('point') !== -1) {
    controlId = item.id.replace('point', '.')
  }
  return controlId.replace('item', '')
}